import { useScreenSize } from "hooks";
import { TAB_WIDTH, TAB_LARGE_WIDTH } from "utils/constants";
import { FetchError, Header, SearchBar } from "components/molecules";
import { Typography, DropDown, Button } from "components/atoms";
import { CourseIndexDetailCardSection } from "components/organisms/CourseIndexDetailCardSection";
import { MOBILE_WIDTH } from "utils/constants";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { Spinner } from "components/atoms/Icon";
import { useGetCourseIndexQuery } from "services/courseIndex";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
}

export const SelfPacedCourseIndex = ({ theme }: IProps) => {
  const screen = useScreenSize();
  const [searchText, setSearchText] = useState<string>("");
  const [topicDropdown, setTopicDropdown] = useState<
    null | string | { [key: number]: string }
  >(null);
  const { isLoading, isError, data } = useGetCourseIndexQuery();

  const handleClear = () => {
    setSearchText("");
    setTopicDropdown(null);
  };

  useEffect(() => {
    if (topicDropdown !== null) {
      setSearchText("");
    }
  }, [topicDropdown]);

  return (
    <div className="self-paced-course-index-container">
      <div className="self-paced-course-index-header-container">
        <div className="self-paced-header-section">
          <Header
            theme={theme}
            leftContentLabel="Course Index"
            leftContentStyle="self-paced-header-custom-style"
            leftContentTypographyStyle="self-paced-left-content-typography-style"
            isTab={screen.width <= TAB_LARGE_WIDTH}
            customVariant={screen.width <= MOBILE_WIDTH ? "h2Bold" : "h3Bold"}
          />
        </div>
      </div>

      {isLoading ? (
        <Spinner theme={theme} />
      ) : isError ? (
        <FetchError content="Oops! failed to load resources." />
      ) : data &&
        data.ParentNodes &&
        Array.isArray(data.ParentNodes) &&
        data.ParentNodes.length > 0 ? (
        <>
          <div className="description-section">
            <Typography
              label="Access all lesson content and drills by subjects and sub-topics."
              variant="h8Book"
            />
          </div>
          <div
            className={classNames(
              screen.width < TAB_WIDTH
                ? "self-paced-drop-down-search-bar-section-inter-tab"
                : "self-paced-drop-down-search-bar-section"
            )}
          >
            <div className="first-drop-down">
              <div className="first-typography-section">
                <Typography
                  label="Select Subject:"
                  variant="h7Book"
                  styles="custom-typography-style"
                />
              </div>
              <div className="drop-down-section">
                <DropDown
                  data={data.ParentNodes.map((node: any) => node.Name).sort()}
                  // data={dropDownData.sort()}
                  styles="drop-down-custom-styles"
                  setDropDownSelection={setTopicDropdown}
                  defaultSelected={topicDropdown}
                />
              </div>
            </div>
            {/* {screen.width > MOBILE_WIDTH ? ( */}
              <div className="second-search">
                <div className="second-typography-section">
                  <Typography label="and" variant="h7Book" />
                </div>
                <div className="search-bar-section">
                  <SearchBar setText={setSearchText} text={searchText} />
                </div>
                <div className="clear-btn">
                  <Button
                    icon={false}
                    label="Clear"
                    type="online"
                    styles="clear-all-btn-typography-style"
                    onClick={handleClear}
                  />
                </div>
              </div>
            {/* ) : null} */}
          </div>
          <div className="detail-card-section">
            <CourseIndexDetailCardSection
              segment={
                topicDropdown === null
                  ? searchText === ""
                    ? null
                    : {
                        LearningTracks: data.ParentNodes.flatMap(
                          (parentNode: any) => parentNode.LearningTracks
                        ).filter((tracks: any) =>
                          Object.values(tracks.Groups).find((objArr: any) =>
                            objArr.find((obj: any) =>
                              obj.Name.toLowerCase().includes(
                                searchText.toLowerCase()
                              )
                            )
                          )
                        ),
                      }
                  : searchText === ""
                  ? data.ParentNodes.find(
                      (node: any) =>
                        node.Name === Object.values(topicDropdown)[0]
                    )
                  : {
                      LearningTracks: data.ParentNodes.find(
                        (node: any) =>
                          node.Name === Object.values(topicDropdown)[0]
                      ).LearningTracks.filter((tracks: any) =>
                        Object.values(tracks.Groups).find((objArr: any) =>
                          objArr.find((obj: any) =>
                            obj.Name.toLowerCase().includes(
                              searchText.toLowerCase()
                            )
                          )
                        )
                      ),
                    }
              }
              theme={theme}
            />
          </div>
        </>
      ) : null}
    </div>
  );
};
